export const OPERATORS_BY_TYPE = {
  char: [
    { label: 'égal à', value: '=' },
    { label: 'différent de', value: '!=' },
    { label: 'contient', value: 'ilike' },
    { label: 'ne contient pas', value: 'not ilike' },
  ],
  text: [
    { label: 'égal à', value: '=' },
    { label: 'différent de', value: '!=' },
    { label: 'contient', value: 'ilike' },
    { label: 'ne contient pas', value: 'not ilike' },
  ],
  selection: [
    { label: 'égal à', value: '=' },
    { label: 'différent de', value: '!=' },
    { label: 'est dans', value: 'in' },
    { label: "n'est pas dans", value: 'not in' },
  ],
  boolean: [
    { label: 'égal à', value: '=' },
    { label: 'différent de', value: '!=' },
  ],
  integer: [
    { label: 'égal à', value: '=' },
    { label: 'différent de', value: '!=' },
    { label: 'supérieur à', value: '>' },
    { label: 'inférieur à', value: '<' },
    { label: 'supérieur ou égal à', value: '>=' },
    { label: 'inférieur ou égal à', value: '<=' },
  ],
  float: [
    { label: 'égal à', value: '=' },
    { label: 'différent de', value: '!=' },
    { label: 'supérieur à', value: '>' },
    { label: 'inférieur à', value: '<' },
    { label: 'supérieur ou égal à', value: '>=' },
    { label: 'inférieur ou égal à', value: '<=' },
  ],
  many2one: [
    { label: 'égal à', value: '=' },
    { label: 'différent de', value: '!=' },
  ],
  many2many: [
    { label: 'contient', value: 'in' },
    { label: 'ne contient pas', value: 'not in' },
  ],
  one2many: [
    { label: 'contient', value: 'in' },
    { label: 'ne contient pas', value: 'not in' },
  ],
  date: [
    { label: 'égal à', value: '=' },
    { label: 'différent de', value: '!=' },
    { label: 'avant', value: '<' },
    { label: 'après', value: '>' },
  ],
  datetime: [
    { label: 'égal à', value: '=' },
    { label: 'différent de', value: '!=' },
    { label: 'avant', value: '<' },
    { label: 'après', value: '>' },
  ],
};